export default {
  cancelReasonLabel: 'Motivo de la cancelación',
  cancelCommentLabel: 'Comentario',
  cancel: 'Cancelar'
};
